import { lazy } from "react";
import { Navigate } from "react-router-dom";
import WithSuspense from "../components/Loaders/WithSuspense";
import { PUBLIC_PATHS } from "./constants";
import InvitedUserSignup from "../pages/Authentication/InvitedUserSignup";
import JoinInvitedUser from "pages/Authentication/JoinInvitedUser";
import OTPScreen from "pages/Authentication/OTPScreen";
import Signup from "pages/Authentication/Signup";
import ResetPassword from "pages/Authentication/ResetPassword";
import Unauthorized from "pages/Authentication/Unauthorized";
import { RequireInviteKey } from "components/common/RequireInviteKey";
import { UserRole } from "../types/users";

// ─── Module Route Imports ────────────────────────────────────────────────────
import { PMO_MODULE_ROUTES } from "./modules/pmo.routes";
import { HRMS_MODULE_ROUTES } from "./modules/hrms.routes";
import { CRM_MODULE_ROUTES } from "./modules/crm.routes";
import { CORE_ROUTES } from "./modules/core.routes";
import { AppRoute } from "./types";

export type { AppRoute };

// ─── Public Pages ────────────────────────────────────────────────────────────
const {
  LOGIN, FORGOT_PASS, INVITED_SIGNUP, ORGANIZATION_ACCOUNT_SETUP,
  SIGNUP, OTP_SCREEN, RESET_PASSWORD, UNAUTHORIZED, JOIN_INVITED_USER,
} = PUBLIC_PATHS;

const Login = WithSuspense(lazy(() => import("../pages/Authentication/Login")));
const ForgotPassword = WithSuspense(lazy(() => import("../pages/Authentication/ForgotPassword")));
const CompanyAccountSetup = WithSuspense(lazy(() => import("../pages/AccountSetup/OrganizationOnboarding/AccountSetup")));

// ─── Helpers ─────────────────────────────────────────────────────────────────
export const getRoutesForRole = (role: UserRole): AppRoute[] => {
  const all = [
    ...CORE_ROUTES,
    ...PMO_MODULE_ROUTES,
    ...HRMS_MODULE_ROUTES,
    ...CRM_MODULE_ROUTES,
  ];
  return all.filter(r => !r.roles || r.roles.length === 0 || r.roles.includes(role));
};

// ─── Public Routes ───────────────────────────────────────────────────────────
export const PUBLIC_ROUTES: AppRoute[] = [
  { path: LOGIN, element: <Login /> },
  { path: SIGNUP, element: <Signup /> },
  { path: FORGOT_PASS, element: <ForgotPassword /> },
  { path: INVITED_SIGNUP, element: <RequireInviteKey><InvitedUserSignup /></RequireInviteKey> },
  { path: OTP_SCREEN, element: <OTPScreen /> },
  { path: ORGANIZATION_ACCOUNT_SETUP, element: <CompanyAccountSetup /> },
  { path: JOIN_INVITED_USER, element: <JoinInvitedUser /> },
  { path: RESET_PASSWORD, element: <ResetPassword /> },
  { path: UNAUTHORIZED, element: <Unauthorized /> },
  { path: "*", element: <Navigate to={LOGIN} replace /> },
];
